import {
  validationObject,
  validateEmail,
  validateRequired,
  validateName,
  validateString,
} from 'utils/validations';
import { CustomerInfo } from 'utils/constants/informationText';
import { getFormInitialValues, optionalFormField } from 'utils/methods/helpers';
import { USER_FIELDS } from 'utils/formFields/user';
import API from 'services/api';
import isEmpty from 'lodash/isEmpty';

export const initialState = {
  archived: false,
  country: '',
  email: undefined,
  emailVerified: false,
  phoneVerified: false,
  firstName: '',
  lastName: '',
  phone: undefined,
  employeeId: undefined,
  businessClient: '',
  notes: '',
  languages: ['EN'],
};

export const initialValues = data => {
  return getFormInitialValues(data);
};

export const validationSchema = validationObject({
  //image: validateRequired(),
  employeeId: validateString(30, false),
  firstName: validateName(30),
  lastName: validateName(30),
  email: validateEmail(true),
  businessClient: validateRequired(),
});

export const generalSection = (
  countries,
  editMode,
  userAssignedDepartments,
) => [
  {
    label: 'Customer ID',
    field: 'employeeId',
    type: 'text',
    required: false,
    size: 'full',
    placeholder: "Enter customer's id. e.g. CUST-0001",
    info: CustomerInfo.customerId,
  },
  {
    field: 'firstName',
    type: 'text',
    required: true,
    size: 'half',
    placeholder: 'Enter first name',
  },
  {
    field: 'lastName',
    type: 'text',
    required: true,
    size: 'half',
    placeholder: 'Enter last name',
  },
  {
    field: 'phone',
    type: 'phone',
    size: 'half',
    secondaryOptions: countries,
  },
  {
    field: 'email',
    type: 'text',
    required: true,
    size: 'half',
    disabled: editMode,
    info: CustomerInfo.email,
    placeholder: 'Enter email',
  },
  ...optionalFormField({
    showWhen: userAssignedDepartments.length > 0,
    field: USER_FIELDS.departments({ userAssignedDepartments }),
  }),
];

export const detailedSection = (
  //  businessClients,
  languages,
  embeddedselectedBusinessClient,
  securityCompanyId,
  selectedDepartments = [],
) => [
  {
    field: 'businessClient',
    type: 'async-select',
    //  info: CustomerInfo.businessClient,
    disabled: !isEmpty(embeddedselectedBusinessClient),
    required: true,
    size: 'half',
    valueType: 'object',
    fetchOptions: API.fetchBusinessClientList,
    fetchFilters: {
      securityCompanyId,
      archived: false,
      ...(!isEmpty(embeddedselectedBusinessClient) && {
        departmentId: embeddedselectedBusinessClient.departmentIds,
      }),
      ...(!isEmpty(selectedDepartments) && {
        departmentId: selectedDepartments
          .map(m => ({ id: m.id }))
          .map(m => m.id),
      }),
    },
    optionLabelKey: 'name',
    resetWhen: [
      {
        value: selectedDepartments,
        condition: val => {
          return val;
        },
      },
    ],
    updateDependentField: [
      // if this component is updated, always clear assignee
      {
        key: 'departments',
        passValue: '', // assign this value
        condition: (_, value, selectedValue, reason) => {
          if (reason === 'clear') {
            return true;
          }
          const assignedBusinessDepartments =
            selectedValue?.assignedDepartmentList; // list of assigned department ids only
          const selectedDepartment = value?.departments; // [] of id and name
          return !selectedDepartment?.some(s =>
            assignedBusinessDepartments.includes(s.id),
          );
        }, // always true, therefore, it will ensure that departments will be deselected when business clients is changed
      },
    ],
    dataTransform: ({ data }) => {
      return data.map(m => ({ ...m, assignedDepartmentList: m.departmentIds }));
    },
  },
  {
    label: 'Languages',
    field: 'languages',
    type: 'multiselect',
    options: languages,
    info: CustomerInfo.languages,
  },
  { field: 'notes', type: 'textArea', maxLength: 250 },
];
